import React from 'react';
import { InformationCircle } from 'AppSrc/core/components/common/svg-icons';
import 'AppSrc/core/style/components/form/modal-errors.css';
import PropTypes from 'prop-types';

const ModalErrors = React.memo(({
  modalErrorsTitle,
  errors,
}) => (
  <div className="modal-errors-wrapper">
    <div className="modal-errors">
      <div className="warning-svg-wrapper">
        <div className="warning-svg">
          <InformationCircle />
        </div>
      </div>
      <div className="error-message">
        <p className="error-section-title">
          {modalErrorsTitle}
        </p>
        {
          errors.length > 0 && (
            <ul className="errors">
              {errors.map((error, index) => (
                <li key={error}>
                  <p>{`- ${error}`}</p>
                </li>
              ))}
            </ul>
          )
        }
      </div>
    </div>
  </div>
));


ModalErrors.propTypes = {
  modalErrorsTitle: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
};

export {
  ModalErrors,
};
